import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { Button, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";
import InputDatePickerMesAno from "components/Inputs/InputDatePickerMesAno";
import MaterialTable from 'material-table';

// utils
import { showMessage } from "utils/message.js";
import { formateMesAno, formateDateByMesAno } from "utils/formats";
import { getSessionCookie } from 'utils/cookies';

// api
import drecomissoesreembolso_api from 'api/drecomissoesreembolso_api';

// constants
import { table_translate } from 'constants/MaterialTable';
import { table_style } from 'constants/MaterialTable';



export default function ComissoesReembolsoDRE() {

    var session = getSessionCookie();

    const { handleSubmit, register, errors, clearErrors, reset } = useForm({ mode: "onBlur" });
    const [showLoading, setshowLoading] = useState(false);

    const [startDate, setStartDate] = useState(formateDateByMesAno(session.mesAnoDefault));
    const [espelhoReembolsoFile, setEspelhoReembolsoFile] = React.useState(null);
    const [espelhoComissaoFile, setEspelhoComissaoFile] = React.useState(null);
    //======== Listagem de Processos ================================//
    const [processos, setProcessos] = useState([]);

    const carregarProcessamento = useCallback(async () => {
        drecomissoesreembolso_api.processamentos().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            } else {
                setProcessos(result.data);
            }
        });
    }, [setProcessos]);

    //===================================================================================CHANGE ARQUIVO================================================================================================//
    const onChangeFileComissao = async (event) => {
        const file = event.target.files[0];
        setEspelhoComissaoFile(file);
        clearErrors("espelhoComissao");
    };

    const onChangeFileReembolso = async (event) => {
        const file = event.target.files[0];
        setEspelhoReembolsoFile(file);
        clearErrors("espelhoReembolso");
    };
    //=======================================================================================================================================================================================================//

    //===================================================================================SUBMIT ARQUIVOS - API================================================================================================//

    const onSubmit = () => {
        setshowLoading(true)
        let mesAno = formateMesAno(startDate);
        drecomissoesreembolso_api.uploadEspelhoComissaoReembolso(mesAno.replace("/", "-"), espelhoComissaoFile, espelhoReembolsoFile).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Arquivos importados com sucesso!", 'success', null);
                reset();
            }
            carregarProcessamento();
        })
    }
    //=======================================================================================================================================================================================================//



    const onShowMessage = (_, { status, mensagem }) => showMessage(status, mensagem, status === "Erro" ? "error" : "info", null);

    const onCancelProcess = (_, { id }) => {
        drecomissoesreembolso_api.cancelarProcessamento(id).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            } else {
                showMessage("Aviso", "Processamento cancelado com sucesso!", 'success', null);
                carregarProcessamento();
            }
        });
    }

    useEffect(() => {
        carregarProcessamento();
    }, [carregarProcessamento]);


    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <h5>Importação Espelho de Comissões e Reembolso </h5>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col lg="2" md="4" sm="4">
                            <FormGroup>
                                <label required className="form-control-label">Mês/Ano *</label>
                                <InputDatePickerMesAno selected={startDate} onChange={(date) => setStartDate(date)} ></InputDatePickerMesAno>
                                {errors.startDate && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col lg="4" md="2" sm="6" className="mt-2">
                            <FormGroup>
                                <label>Espelho Reembolso *</label>
                                <Input
                                    type="file"
                                    accept=".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .xlsb"
                                    label={"Arquivo *"}
                                    variant="outlined"
                                    name="espelhoReembolso"
                                    InputLabelProps={{ shrink: true }}
                                    onChange={onChangeFileReembolso}
                                    innerRef={register({ required: true })}
                                />
                                {errors.espelhoReembolso && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col lg="4" md="4" sm="6" className="mt-2">
                            <FormGroup>
                                <label>Espelho Comissões *</label>
                                <Input
                                    type="file"
                                    label={"Arquivo *"}
                                    accept=".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .xlsb"
                                    variant="outlined"
                                    name="espelhoComissao"
                                    InputLabelProps={{ shrink: true }}
                                    onChange={onChangeFileComissao}
                                    innerRef={register({ required: true })}
                                />
                                {errors.espelhoComissao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                            </FormGroup>
                        </Col>
                        <Col lg="2" md="2" sm="2" className="mt-2">
                            <Button color="success" type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                        </Col>
                    </Row>
                </Form>
                {processos.length > 0 &&
                    <MaterialTable style={{ minHeight: "auto", zIndex: 0 }}
                        title="Lista de Processos"
                        columns={[
                            { title: 'Tipo', field: 'tipo' },
                            { title: 'Mês/Ano', field: 'mesAno' },
                            { title: 'Status', field: 'status' },
                            { title: 'Enviado em', field: 'dataUpload', type: "datetime" },
                            { title: 'Executado em', field: 'dataProcessamento', type: "datetime" }
                        ]}
                        data={processos}
                        isLoading={false}
                        actions={[
                            rowData => ({
                                icon: 'info',
                                tooltip: 'Visualizar Mensagem',
                                iconProps: { color: "primary" },
                                onClick: onShowMessage,
                                hidden: rowData.mensagem == null || rowData.mensagem === ""
                            }),
                            rowData => ({
                                icon: 'cancel',
                                tooltip: 'Cancelar Processamento',
                                onClick: onCancelProcess,
                                iconProps: { color: "error" },
                                hidden: rowData.status !== "Pendente"
                            })
                        ]}
                        localization={table_translate}
                        options={{ ...table_style, actionsColumnIndex: -1, }}
                    />}
            </div>
        </>
    );
}

